'use strict';

var LadderDetailsButtonsDirective = function LadderDetailsButtonsDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'LadderDetailsButtonsController',
    template: require('../templates/ladder-details-buttons.html'),
    scope: {
      currentRow: '=',
      allRows: '=?',
      screenState: '=',
      entryLevelEffectiveFare: '=',
      recommendedFareChartData: '=',
      currentFareChartData: '=',
      chartDataList: '=',
      recalculatedLadder: '=',
      isBenchmarkCompetitor: '=',
      chartSettings: '='
    }
  };
};
LadderDetailsButtonsDirective.$inject = ['$timeout'];
module.exports = LadderDetailsButtonsDirective;